module.exports = __webpack_public_path__ + "img/icon3.38b25218.svg";